import React from "react";
import { Container } from "react-bootstrap";

import { ContentWrapper } from "../components/Nav";
import helpPages from "../data/help";
import "./styles/Help.scss";

export default class HelpExpanded extends React.Component {
  state = {};
  render() {
    const { subpage } = this.props.match.params;
    const helpPage = helpPages[subpage];

    return (
      <ContentWrapper>
        {helpPage ? (
          <Container className="helpContainer">
            <h2>{helpPage.title}</h2>
            <p>{helpPage.summary}</p>
            {helpPage.content.map((entry, index) => {
              const { header, body } = entry;

              return (
                <div key={index}>
                  <h3>{header}</h3>
                  <p>{body}</p>
                </div>
              );
            })}
          </Container>
        ) : (
          <Container className="helpContainer">
            <h2>Sorry, that help page does not exist.</h2>
          </Container>
        )}
      </ContentWrapper>
    );
  }
}
